import { Link } from 'react-router-dom';
import { useState } from 'react';
import { getFormUrl } from './FormHelper';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [subscribeMessage, setSubscribeMessage] = useState('');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    
    setSubscribeStatus('loading');
    try {
      const formUrl = await getFormUrl('快看影视订阅');
      const form = e.currentTarget as HTMLFormElement;
      const formData = new FormData(form);

      const hpValue = formData.get('mobile_alt') as string;
      if (hpValue && hpValue.trim() !== '') {
        setSubscribeStatus('success');
        setSubscribeMessage('订阅成功！感谢您的关注。');
        setEmail('');
        return;
      }

      formData.delete('mobile_alt');

      const response = await fetch(formUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // ignore parse error
      }

      const code = parsed && typeof parsed === 'object' && 'code' in parsed ? (parsed as Record<string, unknown>).code : null;
      const serverMsg = parsed && typeof parsed === 'object' && 'meta' in parsed
        ? (parsed as Record<string, unknown>).meta
        : parsed && typeof parsed === 'object' && 'message' in parsed
          ? (parsed as Record<string, unknown>).message
          : responseText;

      if (response.ok && code === 'OK') {
        setSubscribeStatus('success');
        setSubscribeMessage('订阅成功！感谢您的关注。');
        setEmail('');
      } else {
        const msg = typeof serverMsg === 'string' ? serverMsg : '订阅失败，请稍后重试。';
        setSubscribeStatus('error');
        setSubscribeMessage(msg);
      }
    } catch {
      setSubscribeStatus('error');
      setSubscribeMessage('网络错误，请稍后重试。');
    }
  };

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-lg text-background-950"></i>
              </div>
              <span className="text-xl font-bold text-foreground-50 font-heading">快看影视</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              高清免费电影在线观看，电影大全不缓冲，最新电影免费秒播，流畅高清不卡顿免费看。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4 font-heading">
              <a href="#quick-links" className="cursor-pointer">快速链接</a>
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/category/dongzuo" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">动作片</Link>
              </li>
              <li>
                <Link to="/category/xiju" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">喜剧片</Link>
              </li>
              <li>
                <Link to="/category/kehuan" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">科幻片</Link>
              </li>
              <li>
                <Link to="/category/donghua" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">动画片</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4 font-heading">
              <a href="#about-links" className="cursor-pointer">关于我们</a>
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">品牌介绍</Link>
              </li>
              <li>
                <Link to="/about#testimonials" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">用户口碑</Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">联系我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4 font-heading">订阅更新</h4>
            <p className="text-sm text-foreground-400 mb-3">获取最新电影上线通知</p>
            <form onSubmit={handleSubscribe} className="flex flex-col gap-2" data-readdy-form>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入您的邮箱"
                required
                className="w-full px-4 py-2.5 rounded-lg bg-background-200 border border-background-300 text-sm text-foreground-100 placeholder:text-foreground-500 focus:outline-none focus:border-primary-500 transition-colors"
              />
              <input
                type="text"
                name="mobile_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="hp-field"
              />
              <button
                type="submit"
                disabled={subscribeStatus === 'loading'}
                className="w-full px-4 py-2.5 rounded-lg bg-primary-500 text-background-950 text-sm font-semibold hover:bg-primary-400 transition-all duration-200 disabled:opacity-60 whitespace-nowrap cursor-pointer"
              >
                {subscribeStatus === 'loading' ? '提交中...' : '订阅'}
              </button>
              {subscribeStatus === 'success' && (
                <p className="text-xs text-green-400">{subscribeMessage}</p>
              )}
              {subscribeStatus === 'error' && (
                <p className="text-xs text-accent-400">{subscribeMessage}</p>
              )}
            </form>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 快看影视 kuikanys.com - 高清免费电影在线观看
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}